<template>
  <span>{{ description }}</span>
</template>

<script>
import { getMigrationEventCode } from "@/helpers/variables/migrations";

export default {
  name: "Description",

  props: {
    history: { type: Object, required: true },
  },

  computed: {
    config() {
      const events = getMigrationEventCode();
      return events?.[this.history?.event_code] || {};
    },
    description() {
      const descriptionFn = this.config?.description;

      if (typeof descriptionFn === "function") {
        return descriptionFn(
          this.history?.description?.source_user || "",
          this.history?.description?.destination_group || ""
        );
      }
      return "";
    },
  },
};
</script>
